import request from "./utils/request";

export interface ISystemInfoResp {
  version: string;
}

export function fetchSystemInfo(): Promise<ISystemInfoResp> {
  return request.get("/system/info");
}
